import {
  Card,
  Col,
  Row,
  Image,
  Typography,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Badge,
  Space,
  Empty,
  Spin,
  Modal,
  notification,
  Divider,
  Menu,
} from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import React, { useEffect, useState } from "react";
import iconcheck from "../../Image/iconcheck.png";
import icontime from "../../Image/icontime.png";
import iconcancel from "../../Image/iconcancel.png";
import noresults from "../../Image/no-results.png";
import dayjs, { Dayjs, locale } from "dayjs";
import Icon, {
  CheckCircleOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import { webapi, APIEndpointWeb } from "@client/web";
import { Cookies, useCookies } from "react-cookie";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
} from "@constant/constant";
import * as XLSX from "xlsx-js-style";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Search from "antd/lib/transfer/search";

// import CookieLib from 'js-cookie';

require("dayjs/locale/de");
const Text = Typography;
export interface IConsentSuccess {
  key: React.Key;
  name: string;
  hospital: string;
  hospital_code: string;
  overhead_cost: string;
  insurer: string;
  request_date: string;
  status: string;
}
export interface IPaginate {
  page: number;
  page_last: number;
  total: number;
}
export interface IResAmount {
  request_approve: number;
  request_pending: number;
  request_pending_consent: number;
  request_rejected: number;
  request_success: number;
  request_total: number;
  request_no_history: number;
}
let gPage = 1;
const dateFormat = "DD/MM/YYYY";
const colors = [
  "pink",
  "red",
  "yellow",
  "orange",
  "cyan",
  "green",
  "blue",
  "purple",
  "geekblue",
  "magenta",
  "volcano",
  "gold",
  "lime",
];
const { Option } = Select;
const Dashboard: React.FC = (): JSX.Element => {
  const history = useHistory();
  const [resDashboardInsurance, setResDashboardInsurance] = useState();
  const [exportExcelVal, setExportExcelVal] = useState();
  // const [resDashboardTable, setResDashboardTable] = useState();
  const [loading, setLoading] = useState(false);
  const [paginate, setPaginate] = useState<IPaginate>();
  const [filter] = useState("");
  const [filterUser, setFilterUser] = useState("");
  const [filterhospital, setFilterHospital] = useState("");
  const [datadate] = useState("");
  const [resDatasearch, setResDatasearch] = useState("");
  // const [resSelectdate, setResSelectdate] = useState<Dayjs | any>('');
  const [resSelect, setResSelect] = useState("");
  const [resAmount, setAmount] = useState<IResAmount>();
  const [valueOptions, setValueOptions] = useState<any[]>([]);
  const [ValueOptionsHospital, setValueOptionsHospital] = useState<any[]>([]);
  const [valDateString, setValDateString] = useState<any>("");
  const [iChangePagination, setIchangePagination] = useState<any>();
  const [limit, setLimit] = useState<any>();
  const [WindowResize, setWindowResize] = useState(Number);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    if (WindowResize > 1440 && WindowResize <= 1808) {
      setLimit(10);
    } else if (WindowResize <= 1440) {
      setLimit(5);
    } else if (WindowResize > 1808 && WindowResize <= 2560) {
      setLimit(15);
    }
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  useEffect(() => {
    checkCookie();
    // valExcelExport()
    // DashboardInsurance(gPage, "", datadate, filter, filterUser, filterhospital);
    // filterInsurer()
    // filterHospital()
  }, []);
  const checkCookie = async () => {
    webapi
      .get(`${APIEndpointWeb.checkCookie}`, {
        withCredentials: true,
      })
      .then(() => {
        valExcelExport();
        dashboardtable(gPage, "", datadate, filter, filterUser, filterhospital);
        DashboardInsurance(
          gPage,
          "",
          datadate,
          filter,
          filterUser,
          filterhospital
        );
        filterInsurer();
        filterHospital();
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 401) {
          history.push("/login");
        }
      });
  };
  const dashboardtable = async (
    page: number,
    datasearch: any,
    datadate: any,
    filter: string,
    filterUser: string,
    filterhospital: string
  ) => {
    setLoading(true);
    try {
      const { data } = await webapi.get(
        `${APIEndpointWeb.dashboardtable}?search=${datasearch}&limit=${limit}&page=${page}&date=${datadate}&filter=${filter}&filter_user=${filterUser}&filter_hospital=${filterhospital}`,
        {
          withCredentials: true,
        }
      );
      setResDashboardInsurance(data.result ? data.result : []);
      setPaginate(data.pagination);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const DashboardInsurance = async (
    page: number,
    datasearch: any,
    datadate: any,
    filter: string,
    filterUser: string,
    filterhospital: string
  ) => {
    setLoading(true);
    try {
      const { data } = await webapi.get(
        `${APIEndpointWeb.DashboardInsurance}?search=${datasearch}&limit=${limit}&page=${page}&date=${datadate}&filter=${filter}&filter_user=${filterUser}&filter_hospital=${filterhospital}`,
        {
          withCredentials: true,
        }
      );
      setAmount(data.result ? data.result : []);
      // setResDashboardInsurance(data.result.transaction ? data.result.transaction : []);
      // setPaginate(data.pagination);
      // setLoading(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const valExcelExport = () => {
    try {
      webapi
        .get(`${APIEndpointWeb.DashboardInsurance}`, {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        })
        .then((res: any) => {
          setExportExcelVal(res.data.result.transaction);
        });
      // setExportExcelVal()
    } catch (error) {
      console.log(error);
    }
  };
  const filterInsurer = async () => {
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.filterInsurer}`, {
        withCredentials: true,
        // headers: { Authorization: `Bearer ${cookies.shared_token}` }
      });

      setValueOptions(data.result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const filterHospital = async () => {
    try {
      const { data } = await webapi.get(
        `${APIEndpointWeb.filterHospital}`,

        {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        }
      );
      setValueOptionsHospital(data.result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const onChangePagination = async (page: number): Promise<void> => {
    setIchangePagination(page);
    gPage = page;
    await dashboardtable(
      gPage,
      "",
      valDateString,
      resSelect,
      filterUser,
      filterhospital
    );
  };
  const onChangeDate = (dateString: any) => {
    const dString = dateString ? dateString.format(dateFormat) : "";
    setValDateString(dString);
    dashboardtable(
      1,
      resDatasearch,
      dString,
      resSelect,
      filterUser,
      filterhospital
    );
  };
  const handleChange = (value: string) => {
    setResSelect(value);
    if (iChangePagination > 1) {
      dashboardtable(
        1,
        resDatasearch,
        valDateString,
        value,
        filterUser,
        filterhospital
      );
    } else {
      dashboardtable(
        gPage,
        resDatasearch,
        valDateString,
        value,
        filterUser,
        filterhospital
      );
    }
  };
  const handleChangeinsurer = async (valselectagent: string) => {
    setFilterUser(valselectagent);
    dashboardtable(
      gPage,
      resDatasearch,
      valDateString,
      resSelect,
      valselectagent,
      filterhospital
    );
    // DashboardInsurance(gPage, resDatasearch, datadate, valselectagent)
  };
  const handleChangeHospital = async (valselectHospital: string) => {
    setFilterHospital(valselectHospital);
    dashboardtable(
      gPage,
      resDatasearch,
      valDateString,
      resSelect,
      filterUser,
      valselectHospital
    );
    // DashboardInsurance(gPage, resDatasearch, datadate, valselectagent)
  };
  const handleKeyPress = (event: any, data: any): void => {
    if (event.key === "Enter") {
      dashboardtable(
        1,
        resDatasearch,
        valDateString,
        resSelect,
        filterUser,
        filterhospital
      );
    }
  };

  const exportExcel = async () => {
    const arrayExport: any = resDashboardInsurance;
    if (arrayExport !== null) {
      setLoading(true);
      setTimeout(async () => {
        var wsrows = [];
        var mergevalue: any = [];
        const wb = XLSX.utils.book_new();
        var boderStyle = "thin";
        var boderStyleColor = "000000";
        var boderConfig = {
          bottom: {
            color: { rgb: boderStyleColor },
            style: boderStyle,
          },
          left: {
            color: { rgb: boderStyleColor },
            style: boderStyle,
          },
          right: {
            color: { rgb: boderStyleColor },
            style: boderStyle,
          },
          top: {
            color: { rgb: boderStyleColor },
            style: boderStyle,
          },
        };
        let row2: any = [];
        row2.push([]);
        row2.push([
          {
            v: "เลขที่เอกสาร",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "รายชื่อผู้เอาประกัน",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          // { v: "เลขบัตรประชาชน", t: "s", s: { font: { bold: true, color: { rgb: "ffffff" }, sz: 14 }, border: boderConfig, alignment: { vertical: "center", }, fill: { fgColor: { rgb: "062C3F" } } } },
          {
            v: "โรงพยาบาล",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "รายชื่อผู้ส่งขอประวัติ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "ชื่อบริษัท",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "วันที่ร้องขอ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "วันที่อนุมัติ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "สถานะ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "ค่าดำเนินการ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
          {
            v: "หมายเหตุ",
            t: "s",
            s: {
              font: { bold: true, color: { rgb: "ffffff" }, sz: 14 },
              border: boderConfig,
              alignment: { vertical: "center" },
              fill: { fgColor: { rgb: "062C3F" } },
            },
          },
        ]);
        for (const dataExport of arrayExport) {
          const dateNull =
            dataExport.approved_date === "0001-01-01T00:00:00Z"
              ? ""
              : dayjs(dataExport.approved_date)
                  .locale("th")
                  .add(543, "year")
                  .format("DD/MM/YYYY");
          row2.push([
            {
              v: dataExport.document_id,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dataExport.name,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            // { v: dataExport.cid, t: "s", s: { border: boderConfig, alignment: { vertical: "center" } } },
            {
              v: dataExport.hospital,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dataExport.insurer,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dataExport.insurance,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dayjs(dataExport.request_date)
                .subtract(7, "hour")
                .add(543, "year")
                .format("DD/MM/YYYY"),
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dateNull,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v:
                dataExport.status === "Success"
                  ? "อนุมัติแล้ว"
                  : dataExport.status === "Rejected"
                  ? "ยกเลิก"
                  : dataExport.status === "Pending Consent"
                  ? "รอการยินยอมให้เข้าถึงข้อมูล"
                  : dataExport.status === "Pending Approval"
                  ? "รอการอนุมัติ"
                  : dataExport.status === "Approve"
                  ? "รอการอนุมัติ"
                  : "",
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dataExport.overhead_cost,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
            {
              v: dataExport.remark,
              t: "s",
              s: { border: boderConfig, alignment: { vertical: "center" } },
            },
          ]);
          wsrows.push(
            { hpt: 0 },
            { hpt: 0 },
            { hpt: 0 },
            { hpt: 0 },
            { hpt: 0 }
          );
        }

        const ws = XLSX.utils.aoa_to_sheet(row2);
        ws["!merges"] = mergevalue;
        var wscols = [
          { wch: 25 },
          { wch: 25 },
          { wch: 20 },
          { wch: 25 },
          { wch: 25 },
          { wch: 13 },
          { wch: 13 },
          { wch: 23 },
          { wch: 20 },
          { wch: 30 },
        ];
        ws["!cols"] = wscols;
        ws["!rows"] = wsrows;
        XLSX.utils.book_append_sheet(wb, ws, "readme demo");
        // XLSX.writeFile(wb, `รายการขอประวัติการรักษา.xlsx`);
        XLSX.writeFile(
          wb,
          `รายการขอประวัติการรักษา ${arrayExport[0].insurance}.xlsx`
        );
        setLoading(false);
        notification.open({
          message: `แจ้งเตือน`,
          description: "ดาวน์โหลดเอกสารสำเร็จ",
          // placement,
          icon: <CheckCircleOutlined style={{ color: "#51c41a" }} />,
        });
      }, 1000);
    } else if (arrayExport === null) {
      notification.info({
        message: `แจ้งเตือน`,
        description: "ไม่สามารถดาวน์โหลดเอกสารได้ เนื่องจากไม่มีข้อมูล",
        // placement,
      });
    }
    setLoading(false);
  };
  const columns: ColumnsType<IConsentSuccess> = [
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          เลขที่เอกสาร
        </Text>
      ),
      dataIndex: "document_id",
      key: "document_id",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
          {item}
        </Typography.Text>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          รายชื่อผู้เอาประกัน
        </Text>
      ),
      dataIndex: "name",
      key: "name",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
          {item}
        </Typography.Text>
      ),
    },
    // {
    //     title: <Text className="text-Bold" style={{ textAlign: 'center', fontSize: '12px' }}>เลขบัตรประชาชน</Text>,
    //     dataIndex: "cid",
    //     key: "cid",
    //     render: (item: any, record: IConsentSuccess, index: any) => (
    //         <Typography.Text style={{ textAlign: 'center', fontSize: '12px' }}>
    //             {item}
    //         </Typography.Text>

    //     )
    // },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          โรงพยาบาล
        </Text>
      ),
      dataIndex: "hospital",
      key: "hospital",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Space>
          <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
            {record.hospital}
          </Typography.Text>
        </Space>
        // <Typography.Text style={{ textAlign: 'center', fontSize: '12px' }}>
        //     {item}
        // </Typography.Text>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          รายชื่อผู้ส่งขอประวัติ
        </Text>
      ),
      dataIndex: "insurer",
      key: "insurer",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
          {item}
        </Typography.Text>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          วันที่ร้องขอ
        </Text>
      ),
      dataIndex: "request_date",
      key: "request_date",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
          {dayjs(item)
            .subtract(7, "hour")
            .add(543, "year")
            .format("DD/MM/YYYY")}
        </Typography.Text>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          วันที่อนุมัติ
        </Text>
      ),
      dataIndex: "approved_date",
      key: "approved_date",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <Typography>
          {item === "0001-01-01T00:00:00Z" ? (
            <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
              -
            </Typography.Text>
          ) : (
            <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
              {dayjs(item)
                .subtract(7, "hour")
                .add(543, "year")
                .format("DD/MM/YYYY")}
            </Typography.Text>
          )}
        </Typography>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          สถานะ
        </Text>
      ),
      dataIndex: "status",
      key: "status",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <>
          {item === "Success" ? (
            <Badge status="success" text="อนุมัติแล้ว" />
          ) : item === "Rejected" ? (
            <Badge status="error" text="ยกเลิก" />
          ) : item === "Pending Consent" ? (
            <Badge color="yellow" text="รอการยินยอมให้เข้าถึงข้อมูล" />
          ) : item === "Pending Approval" ? (
            <Badge color="yellow" text="รอการอนุมัติ" />
          ) : item === "Approve" ? (
            <Badge color="yellow" text="รอการอนุมัติ" />
          ) : item === "Pending HIS Approval" ? (
            <Badge color="yellow" text="รอการอนุมัติ" />
          ) : item === "Rejected From Hospital" ? (
            <Badge status="error" text="ไม่พบประวัติ" />
          ) : item === "Request Additional Documents" ? (
            <Badge color="yellow" text="ขอเอกสารเพิ่มเติม" />
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          ค่าดำเนินการ
        </Text>
      ),
      dataIndex: "overhead_cost",
      key: "overhead_cost",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <>
          {/* {item === 'ยังไม่ได้รับค่าดำเนินการ' ? ( */}
          <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
            {item}
          </Typography.Text>
          {/* ) : item === 'ได้รับค่าดำเนินการแล้ว' ? (
                        <Typography.Text style={{ textAlign: 'center', fontSize: '12px' }}>
                            ได้รับค่าดำเนินการแล้ว
                        </Typography.Text>
                    ) : ''} */}
        </>
      ),
    },
    {
      title: (
        <Text
          className="text-Bold"
          style={{ textAlign: "center", fontSize: "12px" }}
        >
          หมายเหตุ
        </Text>
      ),
      dataIndex: "remark",
      key: "remark",
      // ellipsis: true,
      render: (item: any, record: IConsentSuccess, index: any) => (
        <>
          <Typography.Text style={{ textAlign: "center", fontSize: "12px" }}>
            {item}
          </Typography.Text>
        </>
      ),
    },
  ];
  let locale = {
    emptyText: (
      <div style={{ justifyItems: "center" }}>
        <Empty description={"ไม่มีข้อมูล"} />
      </div>
    ),
  };
  function disabledDate(current: any) {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  }
  return (
    <>
      <Spin
        tip="กำลังโหลด..."
        spinning={loading}
        style={{ minHeight: "100vh" }}
      >
        <Row className="pd-5">
          <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
            <Col
              className="dashInsurance p-4 mmmr-4"
              style={{ textAlign: "center" }}
            >
              <Text className="f-c-d">จำนวนเคสทั้งหมด</Text>
              <Col className="sub-card-dashboard ">
                <Col style={{ textAlign: "center" }} className="mt-3 ">
                  <Text className="f-c-d-1 pt-4">
                    {resAmount?.request_total ? resAmount?.request_total : "0"}
                  </Text>
                </Col>
                <Row className="mt-2">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <Text className="text-case">amount</Text>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <Text className="text-case" style={{ color: "#0B818E" }}>
                      Case
                    </Text>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={19}
            xl={19}
            xxl={19}
            className="mart-80 dashInsurance1"
          >
            <Row className="m-4 pb-4">
              <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                <Text className="text2 ml-4">อนุมัติแล้ว</Text>
                <Col className="card-small-green">
                  <Row style={{ justifyContent: "center" }} className="p-4">
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                      <Image
                        alt="lodo"
                        src={iconcheck}
                        preview={false}
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      style={{ textAlign: "center" }}
                    >
                      <Text className="text-gg">
                        {" "}
                        {resAmount?.request_approve
                          ? resAmount?.request_approve
                          : "0"}
                      </Text>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      className="mt-3 right"
                    >
                      <Text className="text-case">case</Text>
                    </Col>
                  </Row>
                </Col>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                xxl={6}
                className="mart-3"
              >
                <Text className="text2 ml-4">รอการอนุมัติ</Text>
                <Col className="card-small-yellow">
                  <Row style={{ justifyContent: "center" }} className="p-4">
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                      <Image
                        alt="lodo"
                        src={icontime}
                        preview={false}
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      style={{ textAlign: "center" }}
                    >
                      <Text className="text-gg">
                        {resAmount?.request_pending
                          ? resAmount?.request_pending
                          : "0"}
                      </Text>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      className="mt-3 right"
                    >
                      <Text className="text-case">case</Text>
                    </Col>
                  </Row>
                </Col>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                xxl={6}
                className="mart-3"
              >
                <Text className="text2 ml-4">ยกเลิก</Text>
                <Col className="card-small-red">
                  <Row style={{ justifyContent: "center" }} className="p-4">
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                      <Image
                        alt="lodo"
                        src={iconcancel}
                        preview={false}
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      style={{ textAlign: "center" }}
                    >
                      <Text className="text-gg">
                        {resAmount?.request_rejected
                          ? resAmount?.request_rejected
                          : "0"}
                      </Text>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      className="mt-3 right"
                    >
                      <Text className="text-case">case</Text>
                    </Col>
                  </Row>
                </Col>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                xxl={6}
                className="mart-3"
              >
                <Text className="text2 ml-4">ไม่พบประวัติ</Text>
                <Col className="card-small-gray">
                  <Row style={{ justifyContent: "center" }} className="p-4">
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
                      <Image
                        alt="lodo"
                        src={noresults}
                        preview={false}
                        style={{
                          width: "30px",
                          height: "30px",
                        }}
                      />
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      style={{ textAlign: "center" }}
                    >
                      <Text className="text-gg">
                        {resAmount?.request_no_history
                          ? resAmount?.request_no_history
                          : "0"}
                      </Text>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      className="mt-3 right"
                    >
                      <Text className="text-case">case</Text>
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className=" mt-5 card-dashboard-i-s p-4"
          >
            {/* <Divider orientation="left" plain>
              ค้นหาประวัติการส่งคำร้อง
            </Divider> */}
            <Row
              className="pr-3 pl-3 mt-4"
              style={{ justifyContent: "center" }}
            >
              <Col
                xs={20}
                sm={20}
                md={20}
                lg={20}
                xl={20}
                xxl={20}
                className="mr-2"
              >
                <p style={{ fontSize: "14px", color: "#808080" }}>
                  ค้นหาประวัติ
                </p>
                <Input
                  placeholder="ค้นหาข้อมูลด้วย เลขที่เอกสาร ชื่อผู้เอาประกัน หรือชื่อผู้ส่งขอประวัติ"
                  allowClear
                  onKeyDown={(event: any) =>
                    handleKeyPress(event, resDatasearch)
                  }
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                    const idNo = e.target.value;
                    const re = /^[A-Za-z\s0-9ก-๛]+$/;
                    if (idNo === "" || re.test(e.target.value)) {
                      setResDatasearch(e.target.value);
                    }
                    if (!e.target.value) {
                      dashboardtable(
                        1,
                        "",
                        valDateString,
                        resSelect,
                        filterUser,
                        filterhospital
                      );
                    }
                  }}
                  value={resDatasearch}
                />
              </Col>
              <Col
                xs={3}
                sm={3}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className="ml-4"
                style={{ marginTop: "37px" }}
              >
                <Button
                  onClick={() =>
                    dashboardtable(
                      1,
                      resDatasearch,
                      valDateString,
                      resSelect,
                      filterUser,
                      filterhospital
                    )
                  }
                  block
                  className="btn-ser"
                >
                  ค้นหา
                </Button>
              </Col>
            </Row>
            {/* </Col> */}
            {/* </Row> */}
            <Row
              className="pr-3 pl-3 mt-4"
              style={{ justifyContent: "center" }}
            >
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                xxl={6}
                className="mr-2"
              >
                <p style={{ fontSize: "14px", color: "#808080" }}>
                  ค้นหาด้วยวันที่
                </p>
                <DatePicker
                  style={{ width: "100%", borderRadius: "10px" }}
                  placeholder="เลือกวันที่"
                  format={dateFormat}
                  onChange={onChangeDate}
                  disabledDate={disabledDate}
                />
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={5}
                xl={5}
                xxl={5}
                className="ml-2 mr-2"
              >
                <p style={{ fontSize: "14px", color: "#808080" }}>
                  ค้นหาโรงพยาบาล
                </p>
                <Form>
                  <Form.Item rules={[{ required: true }]}>
                    <Select
                      onChange={handleChangeHospital}
                      defaultValue="เลือกโรงพยาบาล"
                      filterOption={(input, option: any) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option style={{ fontSize: "16px" }} value="">
                        ทั้งหมด
                      </Option>
                      {ValueOptionsHospital.map((option: any) => (
                        <Option
                          style={{ fontSize: "16px" }}
                          value={option.hospital_code}
                        >
                          {option.hospital_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={4}
                xl={4}
                xxl={4}
                className="ml-2 mr-2"
              >
                <p style={{ fontSize: "14px", color: "#808080" }}>
                  สถานะการอนุมัติ
                </p>
                <Form>
                  <Form.Item rules={[{ required: true }]}>
                    <Select
                      onChange={(value: any) => handleChange(value)}
                      value={resSelect}
                      options={[
                        {
                          value: "",
                          label: "เลือกสถานะ",
                        },
                        {
                          value: "Success",
                          label: "อนุมัติแล้ว",
                        },
                        {
                          value: "Approve" && "Pending Approval",
                          label: "รอการอนุมัติ",
                        },
                        {
                          value: "Pending Consent",
                          label: "รอการยินยอมให้เข้าถึงข้อมูล",
                        },
                        {
                          value: "Rejected",
                          label: "ยกเลิก",
                        },
                        {
                          value: "Rejected From Hospital",
                          label: "ไม่พบประวัติ",
                        },
                        {
                          value: "Request Additional Documents",
                          label: "ขอเอกสารเพิ่มเติม",
                        },
                      ]}
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={4}
                xl={4}
                xxl={4}
                className="ml-2 mr-2"
              >
                <p style={{ fontSize: "14px", color: "#808080" }}>
                  ค้นหาชื่อผู้ส่งขอประวัติ
                </p>
                <Form>
                  <Form.Item rules={[{ required: true }]}>
                    <Select
                      //   showSearch
                      onChange={handleChangeinsurer}
                      defaultValue="เลือกชื่อ"
                      filterOption={(input, option: any) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option style={{ fontSize: "16px" }} value="">
                        ทั้งหมด
                      </Option>
                      {valueOptions.map((option: any) => (
                        <Option
                          style={{ fontSize: "16px" }}
                          value={option.ref_code}
                        >
                          {option.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={3}
                xl={3}
                xxl={3}
                className="ml-3"
                style={{ marginTop: "37px" }}
              >
                <Button
                  onClick={exportExcel}
                  block
                  type="primary"
                  style={{ backgroundColor: "#217346", borderRadius: "10px" }}
                >
                  Export Excel
                  <VerticalAlignBottomOutlined />
                </Button>
              </Col>
            </Row>
            <Divider orientation="left" plain>
              รายละเอียดการขอประวัติการรักษาพยาบาล
            </Divider>
            <Table
              className="mt-2 martTable"
              scroll={{ x: 1005 }}
              pagination={
                paginate
                  ? {
                      showSizeChanger: false,
                      current: paginate.page,
                      pageSize: limit,
                      total: paginate.total,
                      onChange: onChangePagination,
                    }
                  : {}
              }
              locale={locale}
              dataSource={resDashboardInsurance}
              columns={columns}
              // loading={loading}
            />
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default Dashboard;
